<h3 mat-dialog-title>
    {{ 'USERS.CHANGE_LANGUAGE' | transloco }}
</h3>
<mat-dialog-content>
    <mat-form-field appearance="outline">
        <!-- <mat-label> {{ 'LANGUAGES.TITLE' | transloco }}
        </mat-label> -->
        <mat-select [formControl]="langCtrl" required>
            <mat-option *ngFor="let language of languages" [value]="language">
                {{ 'LANGUAGES.' + language | uppercase | transloco }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="langCtrl.hasError('required')">{{ 'FORM_ERRORS.REQUIRED' | transloco }}</mat-error>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="onCancel()">{{ 'CLOSE' | transloco }}</button>
    <button mat-flat-button mat-dialog-close color="primary" [disabled]="langCtrl?.invalid || langCtrl?.pristine" (click)="onSubmit()">{{ 'SAVE' | transloco }}</button>
</mat-dialog-actions>
